import { Button, Modal } from "antd";
import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  deleteAccountRole,
  getAllRoles,
} from "../../../actionCreator/roleManagementActionCreator";
import { useAlert } from "../../../context/AlertProvider";

const DeleteRole = ({ isOpen, handleCancel, callback }) => {
  const dispatch = useDispatch();
  const { showAlert } = useAlert();
  const [isLoading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    const res = await dispatch(deleteAccountRole(isOpen?.id));
    if (res?.status === 204) {
      showAlert("success", `${isOpen?.name} role deleted successfully!`);
      dispatch(getAllRoles());
      callback();
    } else {
      showAlert("error", res?.response?.data?.title);
    }
    setLoading(false);
  };

  return (
    <Modal
      title={null}
      className="delete-popup tw-overflow-hidden"
      open={isOpen}
      centered
      footer={null}
      onOk={handleCancel}
      onCancel={handleCancel}
    >
      <div className="tw-bg-slate-50 tw-text-slate-800 tw-text-lg tw-font-bold tw-py-4 tw-px-6 tw-rounded-t-2xl tw-border tw-border-solid tw-border-slate-100/50 tw-font-inter">
        Delete Role
      </div>
      <div style={{ padding: "24px" }} className="tw-font-inter tw-text-sm tw-text-slate-600">
        Are you sure you want to delete the role "{isOpen?.name}"? This action
        cannot be undone.
      </div>
      <div className="tw-flex tw-bg-slate-50 tw-rounded-b-2xl tw-py-4 tw-px-6 tw-items-center tw-justify-end tw-gap-3 tw-border tw-border-solid tw-border-slate-100/50">
        <Button
          className="!tw-h-[38px] !tw-rounded-lg !tw-border-slate-200 !tw-bg-white !tw-px-5 !tw-text-xs !tw-font-bold !tw-text-slate-500 hover:!tw-border-slate-300 hover:!tw-text-slate-700 tw-transition-all tw-duration-200"
          onClick={handleCancel}
        >
          Cancel
        </Button>
        <Button
          type="primary"
          disabled={isLoading}
          className="!tw-h-[38px] !tw-rounded-lg !tw-bg-red-600 !tw-border-red-600 !tw-text-white tw-text-xs tw-font-bold tw-px-5 tw-shadow-sm hover:!tw-bg-red-700 hover:!tw-border-red-700 tw-transition-all tw-duration-200"
          onClick={() => {
            handleDelete();
            handleCancel();
          }}
        >
          Delete
        </Button>
      </div>
    </Modal>
  );
};

export default DeleteRole;
